import {MDCTabBar} from '@material/tab-bar';

export function init(): void {
	const elem = document.getElementById('top-nav');
	if (elem) {
		new MDCTabBar(elem);
	}
}
